import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

import React from 'react';

export default function AllKPIGraphIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.5785 4.94621L17.5789 4.946L17.5717 4.93528C17.5088 4.84136 17.4238 4.76439 17.3241 4.71116C17.2244 4.65792 17.1131 4.63008 17.0001 4.63008C16.887 4.63008 16.7758 4.65792 16.676 4.71116C16.5763 4.76439 16.4913 4.84136 16.4284 4.93528L16.4281 4.93505L16.4216 4.94621L2.82787 28.3837C2.82786 28.3837 2.82785 28.3837 2.82784 28.3837C2.76886 28.4853 2.73771 28.6007 2.7375 28.7182C2.7373 28.8357 2.76806 28.9512 2.8267 29.053C2.88534 29.1549 2.96978 29.2395 3.07151 29.2983C3.17325 29.3571 3.28869 29.3881 3.4062 29.3881H30.5936C30.5937 29.3881 30.5937 29.3881 30.5937 29.3881C30.7112 29.3881 30.8267 29.3572 30.9284 29.2984C31.0302 29.2396 31.1147 29.155 31.1734 29.0532C31.232 28.9513 31.2628 28.8358 31.2626 28.7183C31.2624 28.6007 31.2313 28.4853 31.1722 28.3836L17.5785 4.94621ZM13.2671 13.0506L17 6.6148L20.7328 13.0506H13.2671ZM8.91743 20.5506L12.4913 14.3881H21.5086L25.0825 20.5506H8.91743ZM25.8583 21.8881L29.4326 28.0506H4.56731L8.14156 21.8881H25.8583Z"
          fill="#00A9A3"
          stroke="#00A9A3"
          strokeWidth="0.4"
        />
      </svg>
    </SvgIcon>
  );
}
